import { isHttpClientError } from "@/shared/http";
import { MissingSessionError } from "../api/connectCodeApi";

const FALLBACK = "연결 코드를 발급하지 못했습니다. 잠시 후 다시 시도해 주세요.";

// Overlord 오류 코드 → 다음 행동. 표에 없는 코드는 원문을 보이지 않고 FALLBACK 으로 안내한다.
const MESSAGES: Record<string, string> = {
  "auth.bearer.invalid": "로그인이 만료되었습니다. 다시 로그인한 뒤 발급해 주세요.",
  "auth.rate_limit.exceeded": "발급 요청이 너무 많습니다. 잠시 후 다시 시도해 주세요.",
  // 이 환경의 Overlord 가 spnp 소비처를 받지 않는다. 사용자가 고칠 수 없다.
  "request.validation_failed":
    "이 환경의 인증 서버는 연결 코드를 지원하지 않습니다. 관리자에게 문의해 주세요.",
};

/** 연결 코드 발급 실패를 사용자 문구로 바꾼다. */
export function connectCodeErrorMessage(error: unknown): string {
  if (error instanceof MissingSessionError) {
    return MESSAGES["auth.bearer.invalid"];
  }
  if (isHttpClientError(error) && error.code !== null) {
    return MESSAGES[error.code] ?? FALLBACK;
  }
  return FALLBACK;
}
